import React from "react";

const SalesTable = ({ headSalesCards, saleCards }) => {
  const years = Object.keys(saleCards).sort((a, b) => Number(a) - Number(b));

  return (
    <div className="table-container" id="calculatingSales">
      <table className="table" id="salesTable">
        <caption className="table-caption">Расчет продаж карт</caption>
        <thead>
          <tr>
            {headSalesCards.map((title, idx) => (
              <th key={idx}>{title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {years.map((year) => {
            const [clients, priceNew, priceOld, meanPrice, sum] =
              saleCards[year];
            return (
              <tr key={year}>
                <td>{year}</td>
                <td style={{ textAlign: "right" }}>
                  {clients.toLocaleString("ru-RU")}
                </td>
                <td style={{ textAlign: "right" }}>
                  {priceNew.toLocaleString("ru-RU")}
                </td>
                <td style={{ textAlign: "right" }}>
                  {priceOld.toLocaleString("ru-RU")}
                </td>
                <td style={{ textAlign: "right" }}>
                  {meanPrice.toLocaleString("ru-RU")}
                </td>
                <td style={{ textAlign: "right" }}>
                  {sum.toLocaleString("ru-RU")}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SalesTable;
